import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let CouponListPopup = class CouponListPopup extends Vue {
    hide(r) {
        this.close(r || {});
    }
};
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "info", void 0);
CouponListPopup = tslib_1.__decorate([
    Component({})
], CouponListPopup);
export default CouponListPopup;
